import type { MemberPortalOrganization, PortalOrganizationSection } from './MemberSignIn'

export function organizationSection(
  organization: MemberPortalOrganization,
  section: PortalOrganizationSection,
) {
  if (organization.permitted_sections) return organization.permitted_sections.includes(section)
  // Older sessions describe only the existing Roster-manager page.
  if (section === 'dashboard') return false
  if (section === 'profile') return organization.profile === true
  return true
}
